import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { PlaceholderCard } from './simple-result-card';

export interface PlaceholderCardsProps {
  cardsCount?: number;
  className?: string;
}
const defaultCount = 1;

/**
 * This component returns the set of Placeholder Cards with a total amount of placeholders based on the cardsCount input
 * Styling is dependent on the viewport.
 * Default return is a single card.
 * Note that React.Children.toArray is simply to add the React "key" to each element.
 * @param cardsCount
 * @param className
 * @return Returns an array of JSX Elements
 */
export const PlaceholderCards: React.FC<PlaceholderCardsProps> = ({ cardsCount = defaultCount, className }) => {
  const placeholderCards = [];
  for (let index = 0; index < cardsCount; index++) {
    placeholderCards.push(
      <Viewport>
        <ViewSmall>
          <PlaceholderCard key={index} index={index} className={className} />
        </ViewSmall>
        <ViewMedium>
          <PlaceholderCard key={index} index={index} className={classNames('placeholder-card', className)} />
        </ViewMedium>
      </Viewport>
    );
  }

  return <>{React.Children.toArray(placeholderCards)}</>;
};
